import { useState } from "react";
import { submitSupportCase } from "../../utils/supportNavUtils";
import useAppStateStore from "../../../../shared/store/AppStateStore";
import ModalWrapper from "../../../../shared/components/ModalWrapper";
import { useNavigate } from "fusion-plugin-react-router";

const ChangeDisclaimer = () => {
  const STATE = useAppStateStore();
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleCheckboxChange = (e) => {
    setTermsAccepted(e.target.checked);
    if (e.target.checked) {
      setError("");
    }
  };

  const onClose = () => {
    STATE.setIsChangeModalOpen(false);
  };

  const onClick = () => {
    if (!termsAccepted) {
      setError("Please confirm that you have read and understood the disclaimer.");
      return;
    }
    onClose();
    submitSupportCase(navigate);
  };

  return (
    <ModalWrapper
      heading="Changes Disclaimer"
      simpleText={
        <div className="tw-flex tw-flex-col tw-gap-3">
          <p className="tw-m-0">
            Please note that changes will only be processed during business
            hours which are Monday to Friday 9am to 4pm. If a change is
            requested outside of business hours to take effect immediately it
            will only be processed during business hours and cover will not be
            back dated.
          </p>
          <p className="tw-m-0">
            Example – a change is requested 9.30pm Saturday to take effect
            10.00am Sunday. This change will only be processed Monday at 9am and
            cover will take effect from Monday at 9am. Cover will not be back
            dated.
          </p>
        </div>
      }
      buttonText="Proceed"
      showClose={true}
      onClose={onClose}
      onButtonClick={onClick}
      showCheckbox={true}
      checkboxLabel={"I have read and understood the disclaimer."}
      checkboxChecked={termsAccepted}
      checkboxError={error}
      onCheckboxChange={handleCheckboxChange}
    />
  );
};

export default ChangeDisclaimer;
